const RevenueSpendPageLangKey = [
	'btn_add_new'
] as const

type IRevenueSpendPageLangKey = typeof RevenueSpendPageLangKey[number]

export type IRevenueSpendPageLang = {
	revenue_spend_page: Record<IRevenueSpendPageLangKey, string>
}

const langEntries = RevenueSpendPageLangKey.map(
	(key: IRevenueSpendPageLangKey) => [key, `revenue_spend_page.${key}`]
)

const langObj: Record<IRevenueSpendPageLangKey, string> = Object.fromEntries(langEntries)

export const REVENUE_SPEND_PAGE_LANG_KEY: IRevenueSpendPageLang = {
	revenue_spend_page: langObj
}
